export default __webpack_public_path__ + "static/ESTAS2023-68f5bebf26962c82bac86216782377d4.png";